import { apiBaseUrl } from "@/environment";

export default {
  //DropDown
  getDefaultDropdown: apiBaseUrl + "api/v1/GetAllDropdownByDefault",
  getCustomerDropdown: apiBaseUrl + "api/v1/GetCustomerDropdown",
  getAdminPageDropdown: apiBaseUrl + "api/v1/GetAdminPageDropdown",
  getReqFormDropdown: apiBaseUrl + "api/v1/GetDropdownForRequestForm",
  getCustomerFormDropdown: apiBaseUrl + "api/v1/GetAllDropdownForCustomerForm",
  getDepartmentDropdown: apiBaseUrl + "api/v1/GetDepartmentDropdown",

  //Request
  searchRequest: apiBaseUrl + "api/v1/Request/Search",
  formRequest: apiBaseUrl + "api/v1/Request/Form",
  formRequestByJobNo: apiBaseUrl + "api/v1/Request/ByJobNo",
  destLocationByIdAndJobNo: apiBaseUrl + "api/v1/DestLocation/ByIdAndJobNo",
  saveRequest: apiBaseUrl + "api/v1/SaveRequest",
  deleteRequest: apiBaseUrl + "api/v1/DeleteRequest", 
  
  //Rider
  acceptRequest: apiBaseUrl + "api/v1/AcceptRequest",
  deliverRequest: apiBaseUrl + "api/v1/DeliverRequest",
  changeRequest: apiBaseUrl + "api/v1/ChangeRequest",

  editRequestByAdmin: apiBaseUrl + "api/v1/EditRequestByAdmin",
  reportRequest: apiBaseUrl + "api/v1/Request/Report",
  reportDeptRequest: apiBaseUrl + "api/v1/Request/DeptReport",
  getRequestDeliveredFile: apiBaseUrl + "api/v1/Request/DeliveredFile",
  getRequestActionLog: apiBaseUrl + "api/v1/Request/ActionLog",

  //Customer
  searchCustomer: apiBaseUrl + "api/v1/Customer/Search",
  formCustomer: apiBaseUrl + "api/v1/Customer/Form",
  saveCustomer: apiBaseUrl + "api/v1/SaveCustomer",
  deleteCustomer: apiBaseUrl + "api/v1/DeleteCustomer",
  saveCustomerLocation: apiBaseUrl + "api/v1/SaveCustomerLocation",
  saveCustomerContact: apiBaseUrl + "api/v1/SaveCustomerContact",
  loadCustomerLocation: apiBaseUrl + "api/v1/LoadCustomerLocation",
  loadCustomerContact: apiBaseUrl + "api/v1/LoadCustomerContact",

  //Department
  searchDepartment: apiBaseUrl + "api/v1/Department/Search",
  saveDepartment: apiBaseUrl + "api/v1/SaveDepartment",
  deleteDepartment: apiBaseUrl + "api/v1/DeleteDepartment",

  //User
  searchUser: apiBaseUrl + "api/v1/User/Search",
  formUser: apiBaseUrl + "api/v1/User/Form",
  saveUser: apiBaseUrl + "api/v1/SaveCreateUser",
  saveUser2: apiBaseUrl + "api/v1/SaveCreateUser2",
  saveUser3: apiBaseUrl + "api/v1/ChangePasswordUser",
  deleteUser: apiBaseUrl + "api/v1/DeleteCreateUser",
  switchUser: apiBaseUrl + "api/v1/SwitchCreateUser",

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: "Bearer",

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: "accessToken",
  storageRefreshTokenKeyName: "refreshToken",
};
